
$(function () {

    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
        window.history.pushState(null, document.title, window.location.href);
    });

    const TODAY_LOCAL = new Date(); 

    const month = String(TODAY_LOCAL.getMonth() + 1).padStart(2, '0'); 
    const day = String(TODAY_LOCAL.getDate()).padStart(2, '0'); 
    const year = TODAY_LOCAL.getFullYear();

    const todayMDY = `${month}/${day}/${year}`;
    const todayYMD = `${year}-${month}-${day}`;

    const UNEXPECTED_ERROR_MESSAGE = "We're sorry, something went wrong while submitting your Property Damage Survey. Please try again later or contact the Appraisal Department at 941-748-8208 for assistance.";
    let formErrorMessage = document.getElementById('form-error-message');
    if(formErrorMessage)
        formErrorMessage.textContent = UNEXPECTED_ERROR_MESSAGE;

    let bandwidthDetected = false;
    let timeoutID; 
    const falconUploadTimeMultiplier = 4.5;

    let _pao_mailing_address_on_file = "";
    let isValid_Parid = false;
    let last_valid_parid = "";
    let last_situs_address = "";
    let last_mailing_address = "";

    const submitButton = document.querySelector('.submit-damage-btn');
    submitButton?.classList.add('disabled');

    const fileInput = document.getElementById("pao-file-input");
    const browseFile = document.getElementById("pao-browse-link");
    fileInput?.classList.add('disabled');
    browseFile?.classList.add('disabled');

    const _parid_input = document.getElementById('pao_parcel_id');
    const _pao_owner_name = document.getElementById('pao_owner_name');
    const _pao_situs_input = document.getElementById('pao_situs_address');
    const _pao_mailing_address_input = document.getElementById('pao_mailing_address');

    Inputmask("(999) 999-9999").mask(document.getElementById("pao_contact_phone"));

    document.getElementById('pao_property_damage').addEventListener('paste', function(event) {
        let paste = (event.clipboardData || window.clipboardData).getData('text');

        paste = paste.replace(/[\r\n]+/g, ' ');  

        event.preventDefault();
        document.execCommand('insertText', false, paste);
    });

        document.getElementById('pao_property_damage').addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();  
        }
    });

    document.getElementById('pao_damage_date').addEventListener('change', function () {
        validateDamageDate();
    });
    document.getElementById('pao_contact_email').addEventListener('blur', function () {
        validateContactEmail();
    });
    document.getElementById('pao_contact_phone').addEventListener('blur', function () {
        validatePhoneNumber();
    });
    document.getElementById('pao_residential_property').addEventListener('change', function () {
        canApplyForTaxRefund();
    });
    document.getElementById('pao_commercial_property').addEventListener('change', function () {
        removeApplyForCatRefundQuestionBlock();
    });
    document.getElementById('pao_parcel_id').addEventListener('blur', function () {
        const dropArea = document.querySelector('.drop-area');
        const browseLink = document.querySelector('.browse-link');
        const paridError = document.querySelector('.parid-error');

        if (last_valid_parid?.length > 0 && isNumeric(last_valid_parid)) {

            dropArea?.classList.remove('disabled');
            browseLink?.classList.remove('disabled');

            paridError.classList.remove('is-invalid');
            paridError.style.display = 'none';

        } else {

            clearTypeaheadSuggestionFields();

            paridError.innerHTML = '<i class="fas fa-exclamation-circle"></i> A Parcel Id is required.';
            paridError?.classList.add('is-invalid');
            paridError.style.display = 'block';

            submitButton?.classList.add('disabled');
            dropArea?.classList.add('disabled');
            browseLink?.classList.add('disabled');

        }
    });
    document.getElementById('pao_mailing_address').addEventListener('input', function (event) {
        mailingAddressValidation();
    });
    document.getElementById('pao_mailing_address').addEventListener('blur', function (event) {
        mailingAddressValidation();
    });

    function showDefaultErrorMessage() {
        formErrorMessage.classList.add('alert-danger');
        formErrorMessage.classList.remove('d-none');
    }

    function hideDefaultErrorMessage() {
        formErrorMessage.classList.remove('alert-danger');
        formErrorMessage.classList.add('d-none');
    }

    function mailingAddressValidation() {
        if (_pao_mailing_address_input.value?.length > 0) {
            let clean = new PaoAddressCleaner(_pao_mailing_address_input.value);
            let address1 = clean.getCleanedAddress();

            clean = new PaoAddressCleaner(_pao_mailing_address_on_file);
            let address2 = clean.getCleanedAddress();

            let el = document.getElementById("pao-address-change-digital-signature-block");
            if (address1 !== address2) {
                if (!el)
                    addChangeAddressSignatureInput();
            }
            if (address1 === address2) {
                if (el) {
                    document.getElementById("pao-change-address-block")?.classList.add('d-none');
                    el.remove();
                }
            }
        }
    }

    function isNumeric(str) {
        return !isNaN(str) && !isNaN(parseFloat(str));
    }



    const engine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        local: [],  
    });

    function clearTypeaheadSuggestionFields() {
        isValid_Parid = false;
        fileInput?.classList.add('disabled');
        browseFile?.classList.add('disabled');

        last_valid_parid = "";
        last_situs_address= "";
        last_mailing_address = "";
        _pao_mailing_address_on_file = "";

        _pao_owner_name.value = "";
        _pao_situs_input.value = "";
        _pao_mailing_address_input.value = "";
    }

    function setTypeaheadSuggestionFields(suggestions) {
        try {
            isValid_Parid = true;
            fileInput?.classList.remove('disabled');
            browseFile?.classList.remove('disabled');

            last_valid_parid = suggestions.PARID;

            if (_parid_input.value !== suggestions.PARID)
                _parid_input.value = suggestions.PARID;

            _pao_owner_name.value = suggestions.OWNER;

            _pao_situs_input.value = suggestions.SITUS;
            last_situs_address = suggestions.SITUS;

                        _pao_mailing_address_input.value = suggestions.MAILING;
            last_mailing_address = suggestions.MAILING;

            if (!_pao_mailing_address_on_file)
                _pao_mailing_address_on_file = _pao_mailing_address_input.value;

            _pao_owner_name.classList.remove('trans-font');
            _pao_situs_input.classList.remove('trans-font');
            _pao_mailing_address_input.classList.remove('trans-font');

            void _pao_owner_name.offsetWidth;
            void _pao_situs_input.offsetWidth;
            void _pao_mailing_address_input.offsetWidth;

            _pao_owner_name.classList.add('trans-font');
            _pao_situs_input.classList.add('trans-font');
            _pao_mailing_address_input.classList.add('trans-font');


        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    $(_parid_input).typeahead(
        {
            hint: true,
            highlight: true,
            minLength: 3,  
        },
        {
            name: 'suggestions',
            limit: 5, 
            source: function (query, syncResults, asyncResults) {
                if (query.length >= 3) {
                    clearTimeout(timeoutID); 
                    timeoutID = setTimeout(function () {
                        lookupParid(query, asyncResults);  
                    }, 300); 
                } else {
                    asyncResults([]);  
                }
            },
            display: function (item) {
                return item.PARID;  
            },
            templates: {
                suggestion: function (data) {
                    return `
                    <div class="pao-tt-suggestion" role="listbox" aria-live="polite" aria-label="Search suggestions">
                      <div class="pao-tt-item" role="option" aria-selected="false">
                        <div><strong>Parcel Id:</strong> ${data.PARID}</div> 
                        <div><strong>Owner:</strong> ${data.OWNER}</div> 
                        <div><strong>Situs Address:</strong> ${data.SITUS}</div>
                      </div>
                    </div>`;
                }
            }
        }
    );

    $(_parid_input).on('typeahead:selected', function (event, suggestions) {
        setTypeaheadSuggestionFields(suggestions);
    });

    $(_parid_input).on('focus', function () {
        var inputWidth = $(this).outerWidth();
        setTimeout(function () {
            $('.tt-menu').css('width', inputWidth); 
        }, 50); 
    });





    $(_parid_input).on('typeahead:close', function () {
        document.getElementById('pao_parcel_id').value = last_valid_parid;
        document.getElementById('pao_situs_address').value = last_situs_address;
        document.getElementById('pao_mailing_address').value = last_mailing_address;
    });


    $(_parid_input).on('typeahead:change', function (event, query) {
        if (!(query?.length > 0)) {
            document.getElementById('pao_parcel_id').value = "";
            clearTypeaheadSuggestionFields();
        }
    });

    function lookupParid(lu_value, asyncResults) {
        try {
            document.getElementById("pao-change-address-block")?.classList.add('d-none');

            let isNumeric = !/[^0-9]/.test(lu_value);
            let obj = {
                job: "parid_search",
                findBy: isNumeric ? "findby-number" : "findby-name",
                findText: lu_value,
                rollType: 'R'
            };

            let json = JSON.stringify(obj);


            fetch('/wp-content/themes/frontier-child/models/pao-model-find-parid.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: 'Request=' + encodeURIComponent(json)
            })
                .then(response => response.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        if (data?.length === 1) {
                            let suggestions = data.reduce((acc, item) => {
                                acc.PARID.push(item.PARID);
                                acc.OWNER.push(item.OWNER);
                                acc.SITUS.push(item.SITUS);
                                acc.MAILING.push(item.MAILING);
                                return acc;
                            }, { PARID: [], OWNER: [], SITUS: [], MAILING: [] });

                            setTypeaheadSuggestionFields(suggestions);
                        } else {
                            clearTypeaheadSuggestionFields();
                        }
                        asyncResults(data);
                    } else if (Array.isArray(data.items)) {
                        let suggestions = data.map(item => [item.PARID, item.OWNER, item.SITUS, item.MAILING]);
                        asyncResults(suggestions);
                    } else {
                        asyncResults([]);  
                    }
                })
                .catch(error => {
                    showDefaultErrorMessage();
                    asyncResults([]);
                });
            } catch (error) {
                showDefaultErrorMessage();
            }
    }

    function addChangeAddressSignatureInput() {
        try {
            let el = document.getElementById("pao-change-address-block");
            if (el) {

                let fragment = document.createDocumentFragment();

                let block = document.createElement("div");
                block.id = "pao-address-change-digital-signature-block";

                let small = document.createElement('small');
                small.classList.add('form-text', 'text-primary', 'question-icon');
                small.ariaLabelledby = 'pao_address_change_digital_signature';
                small.style.fontSize = '0.9rem';
                small.style.fontWeight = 600;
                small.textContent = "We’ve detected a mailing address change. Provide your digital signature (type your name) to change your parcel’s mailing address."
                fragment.appendChild(small);

                let signatureInput = document.createElement("input");
                signatureInput.type = "text";
                signatureInput.id = "pao_address_change_digital_signature";
                signatureInput.name = "pao_address_change_digital_signature";
                signatureInput.classList.add("form-control");
                signatureInput.name = "pao_address_change_digital_signature";
                signatureInput.required = false;
                signatureInput.ariaLabelledby = 'pao_address_change_digital_signature';
                signatureInput.ariaRequired = 'false'; 
                signatureInput.style.width = "365px";
                signatureInput.style.marginBottom = "16px";
                signatureInput.value = "";
                signatureInput.classList.remove('is-valid');
                fragment.appendChild(signatureInput);

                block.appendChild(fragment);

                el.appendChild(block);
                el.classList.add('bg-light', 'p-2', 'mt-2', 'border', 'border-primary');
                el.classList.remove('d-none');
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function changeApplyForCatRefundQuestionBlockToNo() {
        document.getElementById("pao-dectree-questions")?.remove();
    }

    function removeApplyForCatRefundQuestionBlock() {
        let dt = document.getElementById("pao-dectree-container");
        if (dt) {
            document.getElementById("pao-dectree-container").classList.add("d-none");
            document.getElementById("pao-dectree-apply")?.remove();
        }
    }

    function addApplyForTaxRefund(event_tax_year) {
        try {
            let dectree = document.getElementById("pao-dectree-container");
            if (dectree) {
                let dectree_child = document.getElementById("pao-dectree-apply");
                if (!dectree_child) {

                    let block = document.createElement("div");
                    block.id = "pao-dectree-apply";
                    block.classList.add("mb-3");

                    let fragment = document.createDocumentFragment();
                    let div = document.createElement("div");

                    let label = document.createElement("label");
                    label.htmlFor = "pao_apply_for_catastrophic_refund_yes";

                                        label.textContent = `Would you like to apply for a Catastrophic Event Tax Refund for Tax Year ${event_tax_year}?`;
                    label.classList.add("input-required-icon");
                    fragment.appendChild(label);

                    let link = document.createElement("a");
                    link.href = "https://www.manateepao.gov/data/downloads/dr465-Instructions-2023.pdf";
                    link.textContent = "Eligibility and Instructions";
                    link.target = "_blank";
                    link.classList.add("pao-external-link-icon");
                    div.appendChild(link);
                    fragment.appendChild(div);


                    let form_group = document.createElement('div')
                    form_group.classList.add('form-group');                  

                                                              let radio_group = document.createElement('div')
                    radio_group.classList.add('radio-group'); 

                                        let inputYes = document.createElement("input");
                    inputYes.type = "radio";
                    inputYes.id = "pao_apply_for_catastrophic_refund_yes";
                    inputYes.name = "pao_apply_for_catastrophic_refund";
                    inputYes.classList.add("form-check-input", "form-check-inline");
                    inputYes.value = "Yes";
                    inputYes.required = true;
                    inputYes.ariaLabelledby = 'pao_apply_for_catastrophic_refund_yes';
                    inputYes.addEventListener('change', function () {
                        if (inputYes.checked) {
                            addDecisionQuestion1();                          
                        }
                        const form = this;
                        validateForm(form);
                    });                    
                    radio_group.appendChild(inputYes);

                    label = document.createElement("label");
                    label.classList.add("form-check-label", "mr-3");
                    label.htmlFor = "pao_apply_for_catastrophic_refund_yes";
                    label.textContent = "Yes";
                    radio_group.appendChild(label);
                    form_group.appendChild(radio_group);                    


                                        const inputNo = document.createElement("input");
                    inputNo.type = "radio";
                    inputNo.id = "pao_apply_for_catastrophic_refund_no";
                    inputNo.name = "pao_apply_for_catastrophic_refund";
                    inputNo.classList.add("form-check-input", "form-check-inline", "ml-1");
                    inputNo.value = "No";
                    inputNo.required = true;
                    inputNo.ariaLabelledby = 'pao_apply_for_catastrophic_refund_no';
                    inputNo.addEventListener('change', function () {
                        if (inputNo.checked) {
                            changeApplyForCatRefundQuestionBlockToNo();
                        }
                    });                     
                    radio_group.appendChild(inputNo);

                                        label = document.createElement("label");
                    label.classList.add("form-check-label", "ml-4");
                    label.htmlFor = "pao_apply_for_catastrophic_refund_no";
                    label.textContent = "No";
                    radio_group.appendChild(label);
                    form_group.appendChild(radio_group);

                    const errorMessage = document.createElement('div');
                    errorMessage.ariaLive = "assertive";                    
                    errorMessage.ariaAtomic = "true";
                    errorMessage.role = "alert";
                    errorMessage.classList.add("invalid-feedback", "fw-bold", "info-icon");
                    errorMessage.textContent = "Please select 'Yes' or 'No'. This field is required for Residential Property.";
                    radio_group.appendChild(errorMessage);

                                        fragment.appendChild(form_group);
                    block.appendChild(fragment);

                    dectree.appendChild(block)
                    dectree.classList.remove("d-none");
                }
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function addDecisionQuestion1() {
        try {
            let childtree = document.getElementById("pao-dectree-questions");
            if (childtree) 
                childtree.remove();

             if (!childtree) {

                childtree = document.createElement("div");
                childtree.id = "pao-dectree-questions";

                let el = document.getElementById("pao-dectree-block-q1");
                if (!el) {
                    let block = document.createElement("div");
                    block.id = "pao-dectree-block-q1";
                    block.classList.add("mt-4", "mb-3");

                    let fragment = document.createDocumentFragment();
                    let div = document.createElement("div");

                    const span = document.createElement("span");
                    span.textContent = "Please provide additional information for your Catastrophic Event Tax Refund:";
                    span.classList.add("span-label");
                    div.classList.add("mb-2");
                    div.appendChild(span);
                    fragment.appendChild(div);

                    div = document.createElement("div");

                    const label = document.createElement("label");
                    label.htmlFor = "pao_applicant_name";
                    label.textContent = "Applicant Name:";
                    label.classList.add("input-required-icon");
                    div.appendChild(label);

                    const input = document.createElement("input");
                    input.type = "text";
                    input.id = "pao_applicant_name";
                    input.name = "pao_applicant_name";
                    input.maxLength = 40;
                    input.classList.add("form-control");
                    input.required = true;
                    input.ariaLabelledby = 'pao_applicant_name';
                    input.ariaRequired = 'true'; 
                    input.style.width = "472px";
                    input.value = "";
                    div.appendChild(input);

                    const errorMessage = document.createElement('div');
                    errorMessage.ariaLive = "assertive";
                    errorMessage.ariaAtomic = "true";
                    errorMessage.role = "alert";
                    errorMessage.classList.add("invalid-feedback", "fw-bold", "info-icon");
                    errorMessage.textContent = 'Applicant name is required.';

                    div.appendChild(errorMessage);
                    fragment.appendChild(div);
                    block.appendChild(fragment);
                    childtree.appendChild(block);

                    let dectree = document.getElementById("pao-dectree-container");
                    dectree.appendChild(childtree);
                    addDecisionQuestion2();
                    addDecisionQuestionSignature();
                }
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function addDecisionQuestion2() {
        try {
            let childtree = document.getElementById("pao-dectree-questions");
            if (childtree) {
                let el = document.getElementById("pao-dectree-block-q2");
                if (!el) {
                    let block = document.createElement("div");
                    block.id = "pao-dectree-block-q2";
                    block.classList.add("mt-4", "mb-3");

                    let fragment = document.createDocumentFragment();
                    let div = document.createElement("div");

                    const label = document.createElement('label');
                    label.htmlFor = "pao_uninhabitable_days";
                    label.textContent = "Number of days the property was uninhabitable during the calendar year that the catastrophic event occurred (must have been uninhabitable for at least 30 days):";
                    label.classList.add("input-required-icon");
                    div.appendChild(label);

                    const uninhabitable_days_input = document.createElement('input');
                    uninhabitable_days_input.type = "number";
                    uninhabitable_days_input.id = 'pao_uninhabitable_days';
                    uninhabitable_days_input.name = 'pao_uninhabitable_days';
                    uninhabitable_days_input.min = 30;
                    uninhabitable_days_input.required = true;
                    uninhabitable_days_input.ariaLabelledby = 'pao_uninhabitable_days';
                    uninhabitable_days_input.ariaRequired = 'true';
                    uninhabitable_days_input.classList.add("form-control");
                    uninhabitable_days_input.style.width = "90px";
                    uninhabitable_days_input.value = "";
                    div.appendChild(uninhabitable_days_input);

                    const errorMessage = document.createElement('div');
                    errorMessage.ariaLive = "assertive";
                    errorMessage.ariaAtomic = "true";
                    errorMessage.role = "alert";
                    errorMessage.classList.add("invalid-feedback", "fw-bold", "info-icon");
                    errorMessage.textContent = 'Please enter a number greater than 29.';
                    div.appendChild(errorMessage);

                    fragment.appendChild(div);
                    block.appendChild(fragment);

                    uninhabitable_days_input.addEventListener('input', function () {
                        this.value = this.value.replace(/\D/g, '').slice(0, 3); 
                        let numValue = parseInt(this.value, 10); 

                        if (!isNaN(numValue) && numValue > 29) {
                            errorMessage.style.display = 'none';
                        } else {
                            errorMessage.style.display = 'block';
                        }
                    });
                    childtree.appendChild(block);
                    let aply = document.getElementById("pao-dectree-apply");
                    aply.appendChild(childtree);
                    addDecisionQuestion3();
                }
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function addDecisionQuestion3() {
        try {
            let childtree = document.getElementById("pao-dectree-questions");
            if (childtree) {
                let el = document.getElementById("pao-dectree-block-q3");
                if (!el) {

                    let block = document.createElement("div");
                    block.id = "pao-dectree-block-q3";
                    block.classList.add("mt-4", "mb-2");

                    let form_group = document.createElement('div')
                    form_group.classList.add('form-group');                  

                    let label = document.createElement("label");
                    label.htmlFor = "pao_habitable_now_yes";
                    label.textContent = "Has the property been restored to a habitable condition?";
                    label.classList.add("input-required-icon");

                                        form_group.appendChild(label);

                                        let radio_group = document.createElement('div')
                    radio_group.classList.add('radio-group');  


                                        let inputYes = document.createElement("input");
                    inputYes.type = "radio";
                    inputYes.id = "pao_habitable_now_yes";
                    inputYes.name = "pao_habitable_now";
                    inputYes.classList.add("form-check-input", "form-check-inline");
                    inputYes.value = "Yes";
                    inputYes.required = true;
                    inputYes.ariaLabelledby = 'pao_habitable_now_yes';
                    inputYes.addEventListener('change', function () {
                        if (inputYes.checked) 
                            addDecisionQuestion5();
                    });
                    radio_group.appendChild(inputYes);

                    label = document.createElement("label");
                    label.classList.add("form-check-label", "mr-3");
                    label.htmlFor = "pao_habitable_now_yes";
                    label.textContent = "Yes";
                    radio_group.appendChild(label);
                    form_group.appendChild(radio_group);


                                        const inputNo = document.createElement("input");
                    inputNo.type = "radio";
                    inputNo.id = "pao_habitable_now_no";
                    inputNo.name = "pao_habitable_now";
                    inputNo.classList.add("form-check-input", "form-check-inline", "ml-1");
                    inputNo.value = "No";
                    inputNo.required = true;
                    inputNo.ariaLabelledby = 'pao_habitable_now_no';
                    inputNo.addEventListener('change', function () {
                        if (inputNo.checked) {
                            const el = document.getElementById("pao-dectree-block-q4");
                            if (el)
                                el.remove();
                        }
                    });
                    radio_group.appendChild(inputNo);

                    label = document.createElement("label");
                    label.classList.add("form-check-label", "ml-4");
                    label.htmlFor = "pao_habitable_now_no";
                    label.textContent = "No";
                    radio_group.appendChild(label);
                    form_group.appendChild(radio_group);

                    const errorMessage = document.createElement('div');
                    errorMessage.ariaLive = "assertive";                    
                    errorMessage.ariaAtomic = "true";
                    errorMessage.role = "alert";
                    errorMessage.classList.add("invalid-feedback", "fw-bold", "info-icon");
                    errorMessage.textContent = 'Please choose a habitable condition.';
                    radio_group.appendChild(errorMessage);
                    form_group.appendChild(radio_group);

                                        block.appendChild(form_group);
                    childtree.appendChild(block);

                    let aply = document.getElementById("pao-dectree-apply");
                    aply.appendChild(childtree);
                }
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function addDecisionQuestion5() {
        try {
            let q4_block = document.getElementById("pao-dectree-block-q3");
            if (q4_block) {

                let el = document.getElementById("pao-dectree-block-q4");
                if (el)
                    el.classList.remove();

                if (!el) {

                    let block = document.createElement("div");
                    block.id = "pao-dectree-block-q4";
                    block.classList.add("mt-1", "mb-1");

                    let container = document.createElement("div");
                    container.classList.add("mb-3");

                    let fragment = document.createDocumentFragment();
                    let div = document.createElement("div");

                    let label = document.createElement("label");
                    label.htmlFor = "pao_habitable_date";
                    label.textContent = "When was the property habitable?";
                    label.classList.add("form-label", "me-2");
                    label.classList.add("input-required-icon");
                    div.appendChild(label);
                    fragment.appendChild(div);

                    div = document.createElement("div");




                    const habitableDateInput = document.createElement("input");
                    habitableDateInput.type = "date";
                    habitableDateInput.id = "pao_habitable_date";
                    habitableDateInput.name = "pao_habitable_date";
                    habitableDateInput.min = "1970-01-01";
                    habitableDateInput.max = todayYMD;
                    habitableDateInput.classList.add("form-control");
                    habitableDateInput.value = ""; 
                    habitableDateInput.required = true;
                    habitableDateInput.ariaLabelledby = 'pao_habitable_date';
                    habitableDateInput.ariaRequired = 'true';

                    div.appendChild(habitableDateInput);
                    fragment.appendChild(div);

                    let errorLabel = document.createElement("div");
                    errorLabel.id = "error-message";
                    errorLabel.classList.add("text-danger", "info-icon"); 
                    errorLabel.textContent = "A habitable date is required.";
                    div.appendChild(errorLabel);
                    fragment.appendChild(div);

                    habitableDateInput.addEventListener("change", function () {
                        if (!habitableDateInput.value) {
                            errorLabel.classList.remove("d-none"); 
                            return;
                        } else {
                            errorLabel.classList.add("d-none"); 
                        }
                    });
                    block.appendChild(fragment);
                    q4_block.appendChild(block);
                }
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function addDecisionQuestionSignature() {
        try {
            let childtree = document.getElementById("pao-dectree-questions");
            if (childtree) {

                let block = document.createElement("div");
                block.id = "pao-decision-tree-block-esign";
                block.classList.add("mt-4", "mb-3");

                let fragment = document.createDocumentFragment();

                let div = document.createElement("div");

                let label = document.createElement("label");
                label.htmlFor = "pao_signature_name";
                label.textContent = "Signature (Type your name):";
                label.classList.add("form-label", "me-2");
                label.classList.add("input-required-icon");
                div.appendChild(label);
                fragment.appendChild(div);

                let signatureInput = document.createElement("input");
                signatureInput.type = "text";
                signatureInput.id = "pao_signature_name";
                signatureInput.name = "pao_signature_name";
                signatureInput.classList.add("form-control");
                signatureInput.name = "pao_signature_name";
                signatureInput.required = true;
                signatureInput.ariaLabelledby = 'pao_signature_name';
                signatureInput.ariaRequired = 'true';
                signatureInput.style.width = "365px";
                signatureInput.style.marginBottom = "16px";
                signatureInput.value = "";
                div.appendChild(signatureInput);
                fragment.appendChild(div);

                let signatureError = document.createElement("div");
                signatureError.id = "pao-signature-error";
                signatureError.ariaLive = "assertive";                    
                signatureError.ariaAtomic = "true";
                signatureError.role = "alert";
                signatureError.classList.add("invalid-feedback", "fw-bold", "info-icon");
                signatureError.textContent = "Signature is required.";
                div.appendChild(signatureError);
                fragment.appendChild(div);


                let labelDate = document.createElement("label");
                labelDate.classList.add("form-label");
                labelDate.htmlFor = "pao_signature_date";
                labelDate.classList.add("comment-info-icon");
                labelDate.classList.add('d-none');
                div.appendChild(labelDate);
                fragment.appendChild(div);

                let hiddenSignatureDate = document.createElement("input");
                hiddenSignatureDate.type = "text";
                hiddenSignatureDate.id = "pao_signature_date";
                hiddenSignatureDate.name = "pao_signature_date";
                hiddenSignatureDate.classList.add(("d-none"));
                hiddenSignatureDate.value = todayYMD;
                div.appendChild(hiddenSignatureDate);
                fragment.appendChild(div);



                signatureInput.addEventListener("input", function () {
                    if (!signatureInput.value) {
                        labelDate.textContent = '';
                        labelDate.classList.add("d-none"); 
                        signatureError.classList.remove("d-none"); 
                    } else {
                        labelDate.textContent = `Signed on ${todayMDY}`;
                        labelDate.classList.remove("d-none"); 
                        signatureError.classList.add("d-none"); 
                    }
                });


                div = document.createElement("div");
                const subtext = document.createElement('small');
                subtext.classList.add('form-text', 'bg-warning', 'text-dark', 'p-2', 'mt-2', 'digital-signature-icon');
                subtext.id = "pao-signature-digital-tp"
                subtext.ariaLabelledby = 'pao-signature-digital-tp';
                subtext.style.fontSize = '0.8rem';
                subtext.style.fontWeight = 600;
                subtext.textContent = "By typing your name in the Signature box, you declare under penalties of perjury, that you have read this form which acts as your application, and that the facts stated in it are true to the best of your knowledge and belief."
                div.appendChild(subtext);
                fragment.appendChild(div);

                block.appendChild(fragment);
                childtree.appendChild(block);

                let aply = document.getElementById("pao-dectree-apply");
                aply.appendChild(childtree);
            }
        } catch (error) {
            showDefaultErrorMessage();
        }
    }

    function validateDamageDate() {
        try {
            let dateInput = document.getElementById('pao_damage_date');
            let dateParts = dateInput.value.split('-'); 
            let selectedLocalDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);


                        let a = isNaN(selectedLocalDate.getTime());

            let dateErrorInvalid = document.getElementById('pao_date_error_invalid');
            dateErrorInvalid.style.display = 'none';

            if (a) {
                dateErrorInvalid.style.display = 'block';
                dateErrorInvalid.innerHTML = '<i class="fas fa-exclamation-circle"></i> Please select a valid date.';
                dateErrorInvalid.classList.add('is-invalid');
                removeApplyForCatRefundQuestionBlock();
                return false;
            }

            let dateNotInPastError = document.getElementById('pao_date_not_in_past_error');

            if (selectedLocalDate > TODAY_LOCAL) {
                dateNotInPastError.innerHTML = '<i class="fas fa-exclamation-circle"></i> The date must be in the past.';
                dateNotInPastError.style.display = 'block';
                dateNotInPastError.classList.add('is-invalid');
                removeApplyForCatRefundQuestionBlock();
                return;
            }

            dateNotInPastError.style.display = 'none';
            dateNotInPastError.classList.add('is-valid');
            dateNotInPastError.classList.remove('is-invalid');


            dateInput.classList.remove('is-invalid');
            dateInput.classList.add('is-valid');


                        if (document.getElementById('pao_residential_property').checked) {                
                canApplyForTaxRefund();
            }

                    } catch (error) {
            showDefaultErrorMessage();
        }
        return true;
    }

    function validateContactEmail() {
        const emailInput = document.getElementById('pao_contact_email');
        const emailError = document.getElementById('pao_email_error');

        const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
        if (!emailPattern.test(emailInput.value)) {
            emailInput.classList.add('is-invalid');
            emailInput.classList.remove('is-valid');
            emailError.style.display = 'block'; 
        } else {
            emailInput.classList.add('is-valid');
            emailInput.classList.remove('is-invalid');
            emailError.style.display = 'none'; 
        }
    }

    function validatePhoneNumber() {
        const phoneInput = document.getElementById('pao_contact_phone');
        const phoneError = document.getElementById('pao_phone_error');

        const phonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;
        if (!phonePattern.test(phoneInput.value)) {
            phoneInput.classList.add('is-invalid');
            phoneInput.classList.remove('is-valid');
            phoneError.style.display = 'block';
        } else {
            phoneInput.classList.add('is-valid');
            phoneInput.classList.remove('is-invalid');
            phoneError.style.display = 'none';
        }
    }

    document.getElementById("pao_damage_survey_form").addEventListener("submit", async function (event) {
        try {
            event.preventDefault();
            event.stopPropagation();

            hideDefaultErrorMessage();

            const form = this;  
            const validationErrorMessage = document.getElementById("validation-error-message");

            const checkboxGroups = document.querySelectorAll('.checkbox-group');
            let isCheckboxValid = true;

            if (!isValid_Parid) {
                const p = document.querySelector('.parid-error');
                if (p) {
                    p.style.display = 'block';
                    p.classList.add('is-invalid');
                    isCheckboxValid = false;
                    return;
                }
            }

            checkboxGroups.forEach(group => {
                const checkboxes = group.querySelectorAll('input[type="checkbox"]');
                const invalidFeedback = group.querySelector('.invalid-feedback');
                if (invalidFeedback) {
                    const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);

                    if (!isChecked) {
                        invalidFeedback.style.display = 'block';
                        invalidFeedback.classList.add('is-invalid');
                        isCheckboxValid = false;
                        return;
                    } else {
                        invalidFeedback.style.display = 'none';
                        invalidFeedback.classList.remove('is-invalid');
                    }
                }
            });

            if (!form.checkValidity() || !isCheckboxValid) {
                hideDefaultErrorMessage();
                validationErrorMessage.style.display = "block";
            } else {

                submitButton?.classList.add('disabled');

                validationErrorMessage.style.display = "none";
                form.classList.add('was-validated');

                const files = fileInput.files;

                if (!files || files.length === 0) {
                    submitApplication();  
                } else {
                    submitApplication(uncUploadedPaths);  
                }
            }            
        } catch (error) {
            showDefaultErrorMessage();
        }
    });

    function validateCheckboxes() {
        const checkboxGroups = document.querySelectorAll('.checkbox-group');
        let isCheckboxValid = true;

        checkboxGroups.forEach(group => {
            const checkboxes = group.querySelectorAll('.form-check input[type="checkbox"]');
            const invalidFeedback = group.querySelector('.invalid-feedback');
            if (invalidFeedback) {
                const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);

                if (!isChecked) {
                    invalidFeedback.classList.add('d-block');  
                    invalidFeedback.classList.remove('d-none');
                    isCheckboxValid = false;
                    return false
                } else {
                    invalidFeedback.classList.add('d-none');   
                    invalidFeedback.classList.remove('d-block');
                }
            }
        });
        return isCheckboxValid;
    }

    function isValidApplicationForCatRefund() {
        const willApply = document.getElementById("pao_apply_for_catastrophic_refund");
        let i = 0;
        if (willApply?.checked) {
            i = document.getElementById("pao_applicant_name")?.value.length > 0 ? 0 : 1;
            i += document.getElementById("pao_uninhabitable_days")?.value.length > 0 ? 0 : 1;

            let y = document.getElementById("pao_habitable_now_yes");
            if (y?.checked) {
                i += document.getElementById("pao_habitable_date")?.value.length > 0 ? 0 : 1;                
            }
            i += document.getElementById("pao_signature_name")?.value.length > 0 ? 0 : 1;
        }
        return i === 0;
    }

    document.querySelector('#pao_damage_survey_form').addEventListener('input', function () {
        let radios = document.getElementsByName('pao_will_occupy_january');
        if (radios && radios.length > 0) {
            let isChecked = Array.from(radios).some(radio => radio.checked);
            if (isChecked) {
                const form = this;
                validateForm(form);
            }
        }
    });

    async function canApplyForTaxRefund() {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; 

                const eventDate = document.getElementById('pao_damage_date');        
        if (eventDate?.value) {
            const data = {
                event_date: eventDate.value,
                current_date: formattedDate
            };
            try {

                                fetch('/wp-content/themes/frontier-child/models/pao-can-apply-dr465.php', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => response.json())
                .then(result => {
                    if (result?.dr465_event_taxyear > 0) {
                        addApplyForTaxRefund(result.dr465_event_taxyear);
                    } else {
                        removeApplyForCatRefundQuestionBlock();
                    }
                })
                .catch((error) => {
                });

                } catch (error) {
            }
        }
    }

    function validateForm(form) {

        let i = 0;

        const validationErrorMessage = document.getElementById("validation-error-message");

        const isCheckboxValid = validateCheckboxes();


        const dtree_exists = document.getElementById("pao-dectree-questions");
        if (dtree_exists)
            i += isValidApplicationForCatRefund() ? 0 : 1;

        i += isCheckboxValid ? 0 : 1;

        if (i === 0) {
            submitButton?.classList.remove('disabled');
            validationErrorMessage.style.display = "none";
        } else {
            submitButton?.classList.add('disabled');
            validationErrorMessage.style.display = "block";
        }
        form.classList.add('was-validated');
    }

    function debounced(delay, fn) {
        let timerId;
        return function (...args) {
            if (timerId) {
                clearTimeout(timerId);
                n = 0;
            }
            timerId = setTimeout(() => {
                fn(...args);
                timerId = null;
            }, delay);
        }
    }

    const submitApplication = (uncUploadedPaths) => {
        try {
            const form = document.getElementById("pao_damage_survey_form");
            const formData = new FormData(form);
            const data = {};



            let cat_fields = [
                'applicant_name',
                'uninhabitable_days',
                'habitable_now',
                'uninhabitable_days',
                'habitable_date',
                'signature_date',
                'signature_name'
            ];

            let apply_for_refund_yes = formData.get('pao_apply_for_catastrophic_refund');

            let address_change_requested = false;
            let el = document.getElementById("pao_address_change_digital_signature");
            if (el)
                address_change_requested = el.value?.length > 0;


            for (const [key, value] of new FormData(form)) {
                if (apply_for_refund_yes?.toLowerCase() !== 'yes') {
                    if (cat_fields.includes(key))
                        continue;
                }
                if (value) {
                    data[key.replace(/\[|\]/g, '')] = value;
                }
            }


            if (uncUploadedPaths && Array.isArray(uncUploadedPaths)) {
                data['web_upload_unc'] = uncUploadedPaths;
            }

            if (formData.has('pao_damage_causes[]')) {
                const selectedCauses = [];
                formData.forEach((value, key) => {
                    if (key === 'pao_damage_causes[]') {
                        selectedCauses.push(value);
                    }
                });
                data['pao_damage_causes'] = selectedCauses.join(',');
            }

            if (formData.has('pao_habitable_now')) {
                const selectedCauses = [];
                formData.forEach((value, key) => {
                    if (key === 'pao_habitable_now') {
                        selectedCauses.push(value);
                    }
                });
                data['pao_habitable_now'] = selectedCauses.join(',');
            }

            if (address_change_requested) {
                data['pao_address_change_requested'] = 'EMAIL_ADDRESS_CHANGE_REQUESTED';
                data['pao_new_mailing_address'] = _pao_mailing_address_input.value;
                data['address_change_digital_signature'] = data['pao_address_change_digital_signature'];
            } else {
                data['pao_mailing_address'] = _pao_mailing_address_on_file;
            }



                        fetch("/wp-content/themes/frontier-child/models/pao-model-property-damage.php", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(response => response.json())
                .then(result => {
                    if (result?.status === 'error') {
                        formErrorMessage.textContent = result?.message;
                        formErrorMessage.classList.add('alert-danger');
                        formErrorMessage.classList.remove('d-none');
                        document.getElementById("errorblock").scrollIntoView({
                            behavior: "smooth"  
                        });
                    } else {
                        document.getElementById("pao_damage_survey_form")?.reset();
                        submitButton?.classList.remove('disabled');
                        window.location.href = '/pao-property-damage-summary/';
                    }
                })
                .catch((error) => {
                    showDefaultErrorMessage();
                });

            } catch (error) {
                showDefaultErrorMessage();
            }
    };
}); 